<template>
  <LayoutAuthPrimary>
    <BeatLoaderPrimary />
  </LayoutAuthPrimary>
</template>

<script>
  import BeatLoaderPrimary from '@modules/v2/loader/beat-loader-primary'
  import LayoutAuthPrimary from '@modules/v2/layout/layout-auth-primary'
  import { camelToSnake } from '@js/str-utils'

  export default {
    name: 'SsoCallbackView',
    components: {
      BeatLoaderPrimary,
      LayoutAuthPrimary,
    },
    props: {
      state: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        emailIsRegistered: false,
      };
    },
    created: function () {
      if (!this.$route?.query?.state) {
        this.$router.push({ name: 'login' });
      }
      /* TODO(TBD):
       If a new user with sso email domain tries to login
       without knowing if he/she has signed up before,
       the user is redirected to external sign-in page,
       and coming back to zipteam and now he/she sees sign up form
       regardless of that the user has not signed up yet.
       Maybe better to preserve user's intention in state?
      */
    },
    mounted: function () {
      /*
      CAUTION:

      The email obtained from sso_code should be passed as query parameter.
      While it might appear that the email can be fetched by the sso_code
      in another view (e.g., auth-view), this operation can only be
      performed once. This view has already utilized this one-time fetch
      to verify email availability. This limitation stems from the
      backend's workos package, which permits extracting the email
      from sso_code only once.
       */
      const state = JSON.parse(decodeURIComponent(this.$route.query.state));
      const query = {
        code: this.state.ssoCode,
        state: encodeURIComponent(JSON.stringify(state)),
      };

      if (
        this.state.emailVerificationCode.length > 0 ||
        this.state.emailAvailability.isAvailable
      ) {
        this.$router.push({ name: 'signup-continue', query: query });
      } else {
        this.$router.push({ name: 'login-continue', query: query });
      }
    },
  };
</script>
